export function fmtTime(time, cFormat) {
  if (arguments.length === 0) {
    return null
  }

  if (String(time) === '0') {
    return '-'
  }

  if (String(time).length === 10) {
    time = Number(time) * 1000
  }

  const format = cFormat || '{y}-{m}-{d} {h}:{i}:{s}'
  let date
  if (typeof time === 'object') {
    date = time
  } else {
    date = new Date(parseInt(time, 10))
  }

  const formatObj = {
    y: date.getFullYear(),
    m: date.getMonth() + 1,
    d: date.getDate(),
    h: date.getHours(),
    i: date.getMinutes(),
    s: date.getSeconds(),
    a: date.getDay(),
  }
  const timeStr = format.replace(/{(y|m|d|h|i|s|a)+}/g, (result, key) => {
    let value = formatObj[key]
    if (key === 'a') {
      return ['一', '二', '三', '四', '五', '六', '日'][value - 1]
    }
    if (result.length > 0 && value < 10) {
      value = '0' + value
    }
    return value || 0
  })

  return timeStr
}

export function fmtSize(bytes) {
  const a = ['Byte', 'KB', 'MB', 'GB', 'TB']
  let i = 0
  if (Number(bytes) !== 0) {
    while (Number(bytes) >= 1024) {
      bytes /= 1024
      // eslint-disable-next-line no-plusplus
      i++
    }
    const sTemp = Number(bytes).toFixed(2) + a[i]
    return sTemp
  } else if (Number(bytes) === 0) {
    return '0Byte'
  }
  return '-'
}

export function fmtPercent(number) {
  const n = !isFinite(Number(number)) ? 0 : Number(number)
  return (n * 100).toFixed(2) + '%'
}

// eslint-disable-next-line
export function fmtMoney(
  number,
  decimals,
  decPoint,
  thousndsStp,
  currencySign,
) {
  /*
   * 参数说明：
   * number：要格式化的数字
   * decimals：保留几位小数
   * decPoint：小数点符号
   * thousands_sep：千分位符号
   * currencySign：货币符号
   * */
  number = String(number).replace(/[^0-9+-Ee.]/g, '')
  const n = !isFinite(Number(number)) ? 0 : Number(number)
  const prec = !isFinite(Number(decimals)) ? 0 : Math.abs(decimals)
  const sep = typeof thousndsStp === 'undefined' ? ',' : thousndsStp
  const dec = typeof decPoint === 'undefined' ? '.' : decPoint
  let s = ''
  const toFixedFix = function (n, prec) {
    const k = Math.pow(10, prec)
    return String(Math.ceil(n * k) / k)
  }
  s = (prec ? toFixedFix(n, prec) : String(Math.round(n))).split('.')
  const re = /(-?\d+)(\d{3})/
  while (re.test(s[0])) {
    s[0] = s[0].replace(re, '$1' + sep + '$2')
  }

  if ((s[1] || '').length < prec) {
    s[1] = s[1] || ''
    // eslint-disable-next-line no-mixed-operators
    s[1] += new Array(prec - s[1].length + 1).join('0')
  }
  return currencySign ? currencySign + s.join(dec) : s.join(dec)
}

export function fmtSeconds(time, precision = 0) {
  let hh
  let mm
  let ss
  let ms

  // eslint-disable-next-line prefer-const
  ms = `${Math.floor(
    (time - Math.floor(time)) * Math.pow(10, precision),
  )}`.padStart(precision + 1, '.0')
  // 传入的时间为空或小于0
  if (time == null || time < 0) {
    return '00:00:00'
  }
  // 得到小时
  hh = (time / 3600) | 0 // eslint-disable-line
  time = parseInt(time, 10) - hh * 3600
  if (parseInt(hh, 10) < 10) {
    hh = '0' + hh
  }
  // 得到分
  mm = (time / 60) | 0 // eslint-disable-line
  // 得到秒
  ss = parseInt(time, 10) - mm * 60
  if (parseInt(mm, 10) < 10) {
    mm = '0' + mm
  }
  if (ss < 10) {
    ss = '0' + ss
  }

  return hh + ':' + mm + ':' + ss + (precision ? ms : '')
}

// 格式化时间，仅格式化到分钟
export function fmtSeconds2(time, precision = 0) {
  let mm
  let ss
  let ms

  // eslint-disable-next-line prefer-const
  ms = `${Math.floor(
    (time - Math.floor(time)) * Math.pow(10, precision),
  )}`.padStart(precision + 1, '.0')
  // 传入的时间为空或小于0
  if (time == null || time < 0) {
    return '00:00'
  }
  // 得到分
  mm = (time / 60) | 0 // eslint-disable-line
  // 得到秒
  ss = parseInt(time, 10) - mm * 60
  if (parseInt(mm, 10) < 10) {
    mm = '0' + mm
  }
  if (ss < 10) {
    ss = '0' + ss
  }

  return mm + ':' + ss + (precision ? ms : '')
}
// 添加千位分隔符
export function fmtThousands(num) {
  // 将输入转换为字符串，并设定默认值
  num = (num || 0).toString()

  // 检查是否是负数
  const isNegative = num.startsWith('-')

  // 去掉负号进行后续处理
  const absoluteValue = isNegative ? num.slice(1) : num

  // 分割整数部分和小数部分
  const [integerPart, decimalPart] = absoluteValue.split('.')

  let result = ''

  // 对整数部分进行千位分隔处理
  let tempInteger = integerPart
  while (tempInteger.length > 3) {
    result = ',' + tempInteger.slice(-3) + result
    tempInteger = tempInteger.slice(0, tempInteger.length - 3)
  }

  if (tempInteger) {
    result = tempInteger + result // 添加剩余部分
  }

  // 如果有小数部分，则加上小数部分
  if (decimalPart) {
    result += '.' + decimalPart // 维持原小数部分
  }

  // 如果是负数，前面加上负号
  if (isNegative) {
    result = '-' + result
  }

  return result
}

/**
 * 格式化毫秒数，输出格式为：00:00.000
 * @param milliseconds
 * @returns {string}
 */
export function formatMilliseconds(milliseconds) {
  const minutes = Math.floor(milliseconds / 60000)
  const seconds = ((milliseconds % 60000) / 1000).toFixed(3)
  return (
    (minutes < 10 ? '0' : '') +
    minutes +
    ':' +
    (seconds < 10 ? '0' : '') +
    seconds
  )
}

export function formatTime(millisecond) {
  const date = new Date('2022-01-01 00:00:00')
  date.setTime(date.getTime() + millisecond)
  const ms = ('000' + date.getMilliseconds()).slice(-3)
  return `${fmtTime(date, '{i}:{s}')}.${ms}`
}

export function formatTimeWithoutMs(millisecond) {
  const temp = formatTime(millisecond)
  return temp.split('.')[0] || ''
}

// 获取分-秒-毫秒的时间戳
export function TimeToTimestamp(time, millisecond) {
  const parts = time.split(':')
  const seconds =
    Number(parts[0]) * 60 * 60 + Number(parts[1]) * 60 + Number(parts[2])
  return `${Number(String(seconds) + '000') + millisecond}`
}
